export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Ldap.json?hash=279eaacb4c1e1bcc43772f8d18729821";